module.exports = __webpack_public_path__ + "img/ring_r_i_0_1@2x.33504a13.png";